var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderIcon41(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 67,
    viewBox: "0 0 72 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6328 17.9536V45.391H64.5719V21.5994L58.6328 17.9536Z",
    fill: "#1A90B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9766 20.2116V45.391H58.6341V17.9536L54.9766 20.2116Z",
    fill: "#32C3EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0703 11.4971V45.391H52.6805H54.9738V20.2116V15.7191L48.0703 11.4971Z",
    fill: "#1A90B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7539 13.7904V45.391H48.0704V11.4971L44.7539 13.7904Z",
    fill: "#32C3EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79297 21.8111V45.391H13.7438V18.1653L7.79297 21.8111Z",
    fill: "#32C3EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7422 18.1653V45.391H17.388V20.4704L13.7422 18.1653Z",
    fill: "#1A90B9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3867 15.9309V20.4705V45.3911H19.68H24.3019V11.6736L17.3867 15.9309Z",
    fill: "#32C3EB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3047 11.6736V45.3911H27.9152V14.0845L24.3047 11.6736Z",
    fill: "#1A90B9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9141 9.48617V14.0845V45.3911H31.207H36.3346V4.31152L27.9141 9.48617Z",
    fill: "#32C3EB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3359 4.31152V45.3911H41.1578H44.7565V13.7905V9.46265L36.3359 4.31152Z",
    fill: "#1A90B9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8513 64.6902H0.5V66.3602H71.8513V64.6902Z",
    fill: "#1A90B9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8512 22.752L36.3344 0.818604L0.511719 22.7403V24.5514L36.3344 2.58269L71.8512 24.5514V22.752Z",
    fill: "#1A90B9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2978 54.2116C9.98027 53.8 9.69801 53.3883 9.49808 52.7415C9.61569 53.5883 9.59217 54.188 9.59217 54.5761V62.9614H7.83984V50.5305H9.5216L15.5665 58.6218L21.1998 50.5305H23.105V62.9614H21.1998V54.5761V54.3645C21.1998 54.094 21.2704 53.1884 21.2939 52.7533C20.9293 53.5295 20.7177 53.8588 20.553 54.1057L15.8135 60.9974H15.2843L10.2978 54.2116Z",
    fill: "#545353"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8789 47.1316H29.0428V49.4719H26.8789V47.1316ZM28.9958 62.9495H26.9259V50.5304H28.9958V62.9495Z",
    fill: "#545353"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.661 50.5305C41.5192 50.5305 43.2951 50.6246 44.8122 51.7771C46.5998 53.1296 46.9996 55.223 46.9996 56.6695C46.9996 59.2451 45.8236 61.1033 44.4241 61.9971C43.1775 62.7968 41.5545 62.9614 39.661 62.9614H32.8164V50.5305H39.661ZM34.8863 52.2358V61.2444H39.367C40.8136 61.2444 42.4483 61.1738 43.5773 60.1859C44.6593 59.2451 44.8239 57.8926 44.8239 56.693C44.8239 55.7757 44.7063 54.3527 43.6714 53.3883C42.5424 52.3299 40.6842 52.2358 39.3553 52.2358H34.8863Z",
    fill: "#545353"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6687 50.5305L64.584 62.9614H62.2906L60.703 59.9037H52.2942L50.7065 62.9614H48.6602L55.446 50.5305H57.6687ZM59.8562 58.2807L56.5044 51.9418L53.1527 58.2807H59.8562Z",
    fill: "#545353"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon41);
export default __webpack_public_path__ + "static/media/folder_icon4_1.a23d5f88a0b819a7d6c83fbaa974da57.svg";
export { ForwardRef as ReactComponent };